<div class="fixed-scroll" #fixedScroll [style.top]="scrollTop">
    <ng-content></ng-content>
</div>
